import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './timeline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineComponent {}
